/**
 * Dear John parent grouping — PLP/search card collapse + in-card swatch preview
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'djProductGroups';
  var MAX_SEARCH = 30;

  function config() {
    return window.djParentGroupConfig || {};
  }

  function splitPipe(value) {
    return String(value || '')
      .split('||')
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);
  }

  function isBottomsProduct(type, title, tags) {
    var ctx = [type || '', title || '', Array.isArray(tags) ? tags.join(' ') : '']
      .join(' ')
      .toLowerCase();
    return /jean|denim|bottom|pant|short|skirt/.test(ctx);
  }

  function isTopsProduct(type, title, tags) {
    if (isBottomsProduct(type, title, tags)) return false;
    var ctx = [type || '', title || '', Array.isArray(tags) ? tags.join(' ') : '']
      .join(' ')
      .toLowerCase();
    return /top|tee|shirt|blouse|sweater|knit|jacket|dress|tank|cardigan|vest|jumpsuit|romper|bodysuit|hoodie|pullover/.test(
      ctx
    );
  }

  function readCard(el) {
    return {
      el: el,
      handle: el.dataset.djPgHandle || el.dataset.productHandle || '',
      url: el.dataset.djPgUrl || '',
      groups: splitPipe(el.dataset.djPgGroups),
      groupGids: splitPipe(el.dataset.djPgGids),
      primaryGroup: el.dataset.djPgPrimaryGroup || '',
      primaryGid: el.dataset.djPgPrimaryGid || '',
      titleFirst: el.dataset.djPgTitleFirst || '',
      titleRest: el.dataset.djPgTitleRest || '',
      color: el.dataset.djPgColor || '',
      colorPatternId: el.dataset.djPgCpId || '',
      colorPatternLabel: el.dataset.djPgCpLabel || '',
      swatchColor: el.dataset.djPgSwatchColor || '#8A9AAB',
      image: el.dataset.djPgImage || '',
      imageSecondary: el.dataset.djPgImageSecondary || '',
      priceHtml: el.dataset.djPgPriceHtml || '',
      compareHtml: el.dataset.djPgCompareHtml || '',
      onSale: el.dataset.djPgOnSale === 'true',
      available: el.dataset.djPgAvailable !== 'false',
      isBottoms: el.dataset.djPgIsBottoms === 'true',
      isTops: el.dataset.djPgIsTops === 'true'
    };
  }

  function displayColor(data) {
    return data.color || data.colorPatternLabel || '\u00a0';
  }

  function formatMoney(cents) {
    if (window.theme && window.theme.Currency && window.theme.settings && window.theme.settings.moneyFormat) {
      return window.theme.Currency.formatMoney(cents, window.theme.settings.moneyFormat);
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function parseTitleParts(title, colorHint) {
    var cardTitle = String(title || '').trim();
    if (colorHint) {
      var re = new RegExp('\\s*' + colorHint.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*$', 'i');
      cardTitle = cardTitle.replace(re, '').trim();
    }
    var words = cardTitle.split(/\s+/).filter(Boolean);
    return {
      titleFirst: words[0] || '',
      titleRest: words.slice(1).join(' ')
    };
  }

  function cardToStorage(card) {
    return {
      handle: card.handle,
      url: card.url,
      title: [card.titleFirst, card.titleRest].filter(Boolean).join(' '),
      color: displayColor(card),
      colorPatternId: card.colorPatternId,
      swatchColor: card.swatchColor,
      image: card.image,
      groups: card.groups,
      groupGids: card.groupGids,
      isBottoms: card.isBottoms === true,
      isTops: card.isTops === true
    };
  }

  function cropFlags(item) {
    if (item && item.isBottoms === true) return { bottoms: true, tops: false };
    if (item && item.isTops === true) return { bottoms: false, tops: true };
    var title = (item && (item.title || item.handle || '')) || '';
    var bottoms = isBottomsProduct('', title, []);
    return { bottoms: bottoms, tops: !bottoms && isTopsProduct('', title, []) };
  }

  function persistGroups(groupsMap) {
    try {
      var out = {};
      Object.keys(groupsMap).forEach(function (groupName) {
        var bucket = groupsMap[groupName];
        if (bucket.length > 1) {
          out[groupName] = bucket.map(cardToStorage);
        }
      });
      localStorage.setItem(STORAGE_KEY, JSON.stringify(out));
    } catch (err) {
      /* ignore */
    }
  }

  function buildGroupsMap(cards) {
    var map = {};
    cards.forEach(function (card) {
      if (!card.groups.length) return;
      card.groups.forEach(function (groupName) {
        if (!map[groupName]) map[groupName] = [];
        if (!map[groupName].some(function (c) { return c.handle === card.handle; })) {
          map[groupName].push(card);
        }
      });
    });
    return map;
  }

  function findLink(cardEl) {
    return cardEl.querySelector('.grid-product__link');
  }

  function setImgSrc(img, src) {
    if (!img || !src) return;
    img.src = src;
    img.removeAttribute('srcset');
    img.removeAttribute('data-srcset');
  }

  function applyCard(cardEl, data) {
    var link = findLink(cardEl);
    if (link) link.setAttribute('href', data.url || '/products/' + data.handle);

    var titleFirst = cardEl.querySelector('.dj-title-first');
    var titleRest = cardEl.querySelector('.dj-title-rest');
    if (titleFirst) titleFirst.textContent = data.titleFirst || '';
    if (titleRest) titleRest.textContent = data.titleRest || '';

    var colorLine =
      cardEl.querySelector('[data-dj-pg-color-line]') ||
      cardEl.querySelector('.grid-product__color-name');
    if (colorLine) colorLine.textContent = displayColor(data);

    var priceWrap = cardEl.querySelector('.grid-product__price');
    if (priceWrap) {
      if (data.onSale && data.compareHtml) {
        priceWrap.innerHTML =
          '<span class="visually-hidden">Regular price</span>' +
          '<span class="grid-product__price--original">' +
          data.compareHtml +
          '</span>' +
          '<span class="visually-hidden">Sale price</span>' +
          '<span class="sale-price">' +
          data.priceHtml +
          '</span>';
      } else {
        priceWrap.innerHTML = '<span>' + (data.priceHtml || '') + '</span>';
      }
    }

    cardEl.querySelectorAll('.grid-product__image-mask img, .grid-product__link img').forEach(function (img) {
      setImgSrc(img, data.image);
    });

    var secondaryWrap = cardEl.querySelector('.grid-product__secondary-image');
    var secondary = cardEl.querySelector('.grid-product__secondary-image img');
    if (secondaryWrap && secondary) {
      if (data.imageSecondary) {
        setImgSrc(secondary, data.imageSecondary);
        secondaryWrap.style.display = '';
      } else if (data.image) {
        setImgSrc(secondary, data.image);
      }
    }

    cardEl.dataset.djPgActiveHandle = data.handle;
    cardEl._djPgActive = data;
  }

  function renderSwatches(cardEl, bucket, active) {
    var container = cardEl.querySelector('[data-dj-pg-swatches]');
    if (!container) return;

    container.innerHTML = '';
    var seen = {};

    bucket.forEach(function (sibling) {
      var key = sibling.colorPatternId || sibling.handle;
      if (seen[key]) return;
      seen[key] = true;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className =
        'color-swatch color-swatch--small' +
        (sibling.handle === active.handle ? ' is-active' : '');
      btn.dataset.djPgHandle = sibling.handle;
      btn.setAttribute('aria-label', displayColor(sibling) || sibling.handle);
      btn.setAttribute('aria-pressed', sibling.handle === active.handle ? 'true' : 'false');
      btn.style.backgroundColor = sibling.swatchColor || '#8A9AAB';
      if (sibling.image) {
        btn.style.backgroundImage = 'url(' + sibling.image + ')';
        btn.classList.add('color-swatch--with-image');
      }
      var flags = cropFlags(sibling);
      if (flags.bottoms) {
        btn.classList.add('color-swatch--bottoms');
      }
      if (flags.tops) {
        btn.classList.add('color-swatch--tops');
      }

      container.appendChild(btn);
    });
  }

  function pickSwatch(cardEl, picked) {
    var bucket = cardEl._djPgBucket;
    if (!bucket || !picked) return;

    window.__djPgUpdating = true;
    try {
      applyCard(cardEl, picked);
      renderSwatches(cardEl, bucket, picked);
    } finally {
      window.__djPgUpdating = false;
    }
  }

  function bindGridDelegation(root) {
    if (!root || root.dataset.djPgDelegated) return;
    root.dataset.djPgDelegated = 'true';

    root.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest('[data-dj-pg-swatches] button.color-swatch');
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        var cardEl = btn.closest('[data-dj-pg-card]');
        var bucket = cardEl && cardEl._djPgBucket;
        if (!bucket || !bucket.length) return;

        var handle = btn.dataset.djPgHandle;
        var picked =
          bucket.find(function (c) {
            return c.handle === handle;
          }) ||
          bucket.find(function (c) {
            return displayColor(c) === btn.getAttribute('aria-label');
          });

        if (picked) pickSwatch(cardEl, picked);
      },
      true
    );
  }

  function mountGroupedCard(cardEl, bucket, initialActive) {
    cardEl._djPgBucket = bucket;

    var activeHandle =
      cardEl.dataset.djPgActiveHandle ||
      (cardEl._djPgActive && cardEl._djPgActive.handle) ||
      initialActive.handle;

    var active =
      bucket.find(function (c) {
        return c.handle === activeHandle;
      }) || initialActive;

    window.__djPgUpdating = true;
    try {
      applyCard(cardEl, active);
      renderSwatches(cardEl, bucket, active);
    } finally {
      window.__djPgUpdating = false;
    }
  }

  function normalizeGid(id) {
    return String(id || '').toLowerCase().trim();
  }

  function storefrontSearch(domain, token, query) {
    if (!domain || !token || !query) return Promise.resolve([]);

    return fetch('https://' + domain + '/api/2025-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token
      },
      body: JSON.stringify({
        query:
          'query($q:String!){search(query:$q,types:PRODUCT,first:' +
          MAX_SEARCH +
          '){nodes{... on Product{handle title featuredImage{url} pg:metafield(namespace:"custom",key:"product_groups"){references(first:3){nodes{... on Metaobject{id field(key:"name"){value}}}}} cp:metafield(namespace:"shopify",key:"color-pattern"){references(first:1){nodes{... on Metaobject{id color:field(key:"color"){value} label:field(key:"label"){value}}}}}}}}',
        variables: { q: query }
      })
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (payload) {
        return (((payload || {}).data || {}).search || {}).nodes || [];
      })
      .catch(function () {
        return [];
      });
  }

  function fetchProductJs(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin'
    }).then(function (r) {
      if (!r.ok) throw new Error('product js failed');
      return r.json();
    });
  }

  function productJsToCard(data, groups, groupGids, cpColor, cpLabel, cpId) {
    var colorOpt = (data.options || []).find(function (o) {
      return /color|colour/i.test(o.name);
    });
    var color = cpLabel || (colorOpt && colorOpt.values && colorOpt.values[0]) || '';
    var parts = parseTitleParts(data.title, color);
    var onSale = Number(data.compare_at_price) > Number(data.price);
    var priceHtml = formatMoney(data.price);
    if (data.price_varies) {
      priceHtml = 'From ' + formatMoney(data.price_min || data.price);
    }

    return {
      handle: data.handle,
      url: '/products/' + data.handle,
      groups: groups || [],
      groupGids: groupGids || [],
      titleFirst: parts.titleFirst,
      titleRest: parts.titleRest,
      color: color,
      colorPatternId: cpId || '',
      colorPatternLabel: cpLabel || '',
      swatchColor: cpColor || '#8A9AAB',
      image: data.featured_image || '',
      imageSecondary: data.images && data.images[1] ? data.images[1] : '',
      priceHtml: priceHtml,
      compareHtml: onSale ? formatMoney(data.compare_at_price) : '',
      onSale: onSale,
      available: data.available,
      isBottoms: isBottomsProduct(data.type, data.title, data.tags),
      isTops: isTopsProduct(data.type, data.title, data.tags)
    };
  }

  function mapSearchNode(node, targetGid) {
    var pgRefs = (((node.pg || {}).references || {}).nodes || []);
    var match = pgRefs.some(function (ref) {
      return normalizeGid(ref.id) === normalizeGid(targetGid);
    });
    if (!match) return null;

    var cp = (((node.cp || {}).references || {}).nodes || [])[0] || {};
    var cpColor = cp.color && cp.color.value ? cp.color.value : '';
    var cpLabel = cp.label && cp.label.value ? cp.label.value : '';

    return {
      handle: node.handle,
      colorPatternId: cp.id || '',
      cpColor: cpColor,
      cpLabel: cpLabel,
      image: node.featuredImage ? node.featuredImage.url : ''
    };
  }

  function mergeBucket(existing, incoming) {
    var out = existing.slice();
    incoming.forEach(function (item) {
      if (!out.some(function (c) { return c.handle === item.handle; })) {
        out.push(item);
      }
    });
    return out;
  }

  function enrichBucket(groupName, groupGid, bucket, seedCard) {
    var cfg = config();
    if (!cfg.storefrontDomain || !cfg.storefrontToken) {
      return Promise.resolve(bucket);
    }

    return storefrontSearch(cfg.storefrontDomain, cfg.storefrontToken, groupName).then(function (nodes) {
      var refs = nodes
        .map(function (n) {
          return mapSearchNode(n, groupGid);
        })
        .filter(Boolean);

      var known = {};
      bucket.forEach(function (c) {
        known[c.handle] = true;
      });

      var fetches = refs
        .filter(function (ref) {
          return !known[ref.handle];
        })
        .map(function (ref) {
          return fetchProductJs(ref.handle)
            .then(function (p) {
              return productJsToCard(
                p,
                seedCard.groups,
                seedCard.groupGids,
                ref.cpColor,
                ref.cpLabel,
                ref.colorPatternId
              );
            })
            .catch(function () {
              return null;
            });
        });

      return Promise.all(fetches).then(function (extra) {
        return mergeBucket(bucket, extra.filter(Boolean));
      });
    });
  }

  function mutationIsGridReload(mutations) {
    return mutations.some(function (m) {
      var nodes = []
        .concat(Array.from(m.addedNodes || []), Array.from(m.removedNodes || []))
        .filter(function (n) {
          return n.nodeType === 1;
        });

      return nodes.some(function (node) {
        if (node.matches && node.matches('[data-dj-pg-card]')) return true;
        if (node.querySelector && node.querySelector('[data-dj-pg-card]')) return true;
        return false;
      });
    });
  }

  function initGrid(root) {
    if (!root) return;

    window.__djPgUpdating = true;

    try {
      var cardEls = root.querySelectorAll('[data-dj-pg-card]');
      if (!cardEls.length) return;

      bindGridDelegation(root);

      var cards = Array.prototype.map.call(cardEls, readCard);
      var groupsMap = buildGroupsMap(cards);

      root.querySelectorAll('.dj-pg-collapsed').forEach(function (el) {
        el.classList.remove('dj-pg-collapsed');
        el.hidden = false;
      });

      var seenGroups = {};
      var enrichments = [];

      cards.forEach(function (card) {
        if (!card.groups.length) return;

        var groupName = card.groups.find(function (g) {
          return (groupsMap[g] || []).length > 1;
        });

        if (!groupName) {
          groupName = card.primaryGroup || card.groups[0];
          if (!groupName) return;

          mountGroupedCard(card.el, [card], card);

          enrichments.push(
            enrichBucket(groupName, card.primaryGid, [card], card).then(function (bucket) {
              if (bucket.length > 1) {
                groupsMap[groupName] = bucket;
                mountGroupedCard(card.el, bucket, card);
              }
            })
          );
          return;
        }

        if (seenGroups[groupName]) {
          card.el.classList.add('dj-pg-collapsed');
          card.el.hidden = true;
          return;
        }

        seenGroups[groupName] = true;
        var bucket = groupsMap[groupName].slice();
        mountGroupedCard(card.el, bucket, card);
        card.el.dataset.djPgGroup = groupName;

        if (bucket.length < 3 && card.primaryGid) {
          enrichments.push(
            enrichBucket(groupName, card.primaryGid, bucket, card).then(function (fullBucket) {
              if (fullBucket.length > bucket.length) {
                groupsMap[groupName] = fullBucket;
                var activeHandle = card.el.dataset.djPgActiveHandle || card.handle;
                var active =
                  fullBucket.find(function (c) {
                    return c.handle === activeHandle;
                  }) || card;
                mountGroupedCard(card.el, fullBucket, active);
              }
            })
          );
        }
      });

      Promise.all(enrichments).then(function () {
        persistGroups(groupsMap);
      });

      persistGroups(groupsMap);
    } finally {
      window.__djPgUpdating = false;
    }
  }

  function observeCollectionAjax() {
    var host = document.getElementById('CollectionAjaxContent');
    if (!host || host.dataset.djPgObserved) return;
    host.dataset.djPgObserved = 'true';

    var timer;
    var obs = new MutationObserver(function (mutations) {
      if (window.__djPgUpdating) return;
      if (!mutationIsGridReload(mutations)) return;

      clearTimeout(timer);
      timer = setTimeout(function () {
        initGrid(document.querySelector('.product-grid-container'));
      }, 120);
    });
    obs.observe(host, { childList: true, subtree: true });
  }

  function getStoredSiblings(groupName) {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      return parsed[groupName] || null;
    } catch (err) {
      return null;
    }
  }

  function mountPdpSwatches(context, siblings) {
    var colorFieldset = document.querySelector(
      '.variant-input-wrap[data-handle="color"], .variant-input-wrap[data-handle="colour"]'
    );
    if (!colorFieldset) return;

    var wrapper = colorFieldset.closest('.variant-wrapper');
    if (!wrapper || siblings.length < 2) return;

    wrapper.classList.add('is-dj-pg-grouped');

    var host = wrapper.querySelector('.dj-pg-pdp-swatches');
    if (!host) {
      host = document.createElement('div');
      host.className = 'dj-pg-pdp-swatches';
      host.setAttribute('data-dj-pg-pdp-swatches', 'true');
      colorFieldset.appendChild(host);
    }

    host.innerHTML = '';
    siblings.forEach(function (sibling) {
      var isCurrent = sibling.handle === context.handle;
      var el = document.createElement('a');
      el.className = 'color-swatch' + (isCurrent ? ' is-active' : '');
      el.href = sibling.url || '/products/' + sibling.handle;
      el.setAttribute('aria-label', sibling.color || sibling.title || sibling.handle);
      el.setAttribute('aria-pressed', isCurrent ? 'true' : 'false');
      if (isCurrent) el.setAttribute('aria-current', 'true');
      el.style.backgroundColor = sibling.swatchColor || '#8A9AAB';
      if (sibling.image) {
        el.style.backgroundImage = 'url(' + sibling.image + ')';
        el.classList.add('color-swatch--with-image');
      }
      var flags = cropFlags(sibling);
      if (flags.bottoms) {
        el.classList.add('color-swatch--bottoms');
      }
      if (flags.tops) {
        el.classList.add('color-swatch--tops');
      }
      el.textContent = sibling.color || sibling.title || sibling.handle;
      host.appendChild(el);
    });
  }

  function initPdp() {
    var node = document.getElementById('dj-pg-pdp-context');
    if (!node) return;

    var context;
    try {
      context = JSON.parse(node.textContent || '{}');
    } catch (err) {
      return;
    }

    if (!context.groups || !context.groups.length || !context.groupGids || !context.groupGids.length) {
      return;
    }

    var groupName = context.groups[0];
    var groupGid = context.groupGids[0];
    var stored = getStoredSiblings(groupName);

    if (stored && stored.length > 1) {
      mountPdpSwatches(context, stored);
      return;
    }

    var cfg = config();
    storefrontSearch(
      cfg.storefrontDomain || context.storefrontDomain,
      cfg.storefrontToken || context.storefrontToken,
      groupName
    )
      .then(function (nodes) {
        var refs = nodes
          .map(function (n) {
            return mapSearchNode(n, groupGid);
          })
          .filter(Boolean);

        return Promise.all(
          refs.map(function (ref) {
            return fetchProductJs(ref.handle)
              .then(function (p) {
                return productJsToCard(
                  p,
                  context.groups,
                  context.groupGids,
                  ref.cpColor,
                  ref.cpLabel,
                  ref.colorPatternId
                );
              })
              .catch(function () {
                return null;
              });
          })
        );
      })
      .then(function (siblings) {
        siblings = siblings.filter(Boolean);
        if (siblings.length < 2) return;

        try {
          var raw = localStorage.getItem(STORAGE_KEY);
          var parsed = raw ? JSON.parse(raw) : {};
          parsed[groupName] = siblings.map(cardToStorage);
          localStorage.setItem(STORAGE_KEY, JSON.stringify(parsed));
        } catch (err) {
          /* ignore */
        }

        mountPdpSwatches(context, siblings);
      });
  }

  function boot() {
    initGrid(document.querySelector('.product-grid-container'));
    observeCollectionAjax();
    initPdp();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
